// Must stay in sync with HONEYPOT_FIELD_NAME in the backend
// (stww-hauptseite: src/forms/views.py). The backend rejects any submission
// where this field has a value.
export const HONEYPOT_FIELD_NAME = 'homepage';

function Honeypot() {
  return (
    <div aria-hidden='true' className='sweet'>
      <input
        type='text'
        name={HONEYPOT_FIELD_NAME}
        tabIndex={-1}
        autoComplete='off'
        defaultValue=''
      />
    </div>
  );
}

export default Honeypot;
